import React from 'react';
import classes from "./InfoPage.module.css";
import Header from '../components/Header';

const InfoPage = () => {
    return (
        <>
            <Header />
            <div className={classes.container}>
                <div className={classes.description}>
                    <h2 className={classes.title}>Request Submitted</h2>
                    <ul className={classes.list}>
                        <li className={classes.text}>
                            Your subscription request is submitted.
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default InfoPage